import { Title as DialogTitle } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { clsx } from 'clsx';

import { Button } from 'src/components/mainComponents/Button';
import { Drawer } from 'src/components/mainComponents/Drawer';
import { SidebarNavigationContent } from 'src/components/mainComponents/SidebarNavigationContent';
import { AccountInfo } from 'src/components/v2/HeaderBar/AccountInfo';
import useDisclosure from 'src/hooks/useDisclosure';

import './SidebarNavigation.scss';

export function SidebarNavigation({ className: additionalClassName, trainingSessionId = null }) {
  const className = clsx('SidebarNavigationTrigger', additionalClassName);
  const { open, close, isOpen } = useDisclosure();
  return (
    <>
      <Button icon='burger--menu' onClick={open} className={className} variant='text' size='xl' />
      <Drawer isOpen={isOpen} onClose={close}>
        <DialogTitle asChild>
          <VisuallyHidden>Menu principal</VisuallyHidden>
        </DialogTitle>
        <div className='SidebarNavigationTrigger__SidebarNavigation'>
          <div className='SidebarNavigationTrigger__SidebarNavigationHeader'>
            <Button icon='burger--menu' onClick={close} variant='text' size='xl' />
            <AccountInfo />
          </div>
          <div className='SidebarNavigationTrigger__SidebarNavigationContent'>
            <SidebarNavigationContent trainingSessionId={trainingSessionId} />
          </div>
        </div>
      </Drawer>
    </>
  );
}
